<template>
  <base-content>
    <div class="tw-flex-col">
      <span class="tw-text-xl tw-font-thin tw-mb-6 tw-text-gray-800">Activation Checklist</span>
      <base-list-group listType="ordered" class="tw-mt-4">
        <base-list-item class="tw-cursor-pointer hover:tw-bg-gray-50 tw-rounded-t-md">
          <div class="tw-flex tw-justify-between" @click="href(`/businesses/${businessId}/business/profile`)">
            <div class="tw-flex">
              <div class="tw-my-auto tw-mr-6">
                <base-checkbox disabled v-if="!hasBusinessProfile" />
                <base-checkbox disabled :value="1" :values="[1]" class="tw-text-green-500" v-if="hasBusinessProfile" />
              </div>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-800">Configure Business Profile</span>
                <span class="tw-text-gray-600 tw-text-xs">Setup basic business details of your business including headquarters address and billing contact information</span>
              </div>
            </div>
            <div class="tw-flex-none tw-w-4 tw-h-4 tw-my-auto">
              <chevron-right-icon />
            </div>
          </div>
        </base-list-item>
        <base-list-item class="tw-cursor-pointer hover:tw-bg-gray-50">
          <div class="tw-flex tw-justify-between" @click="href(`/businesses/${businessId}/business/locations`)">
            <div class="tw-flex">
              <div class="tw-my-auto tw-mr-6">
                <base-checkbox disabled v-if="!hasLocation" />
                <base-checkbox disabled :value="1" :values="[1]" class="tw-text-green-500" v-if="hasLocation" />
              </div>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-800">Setup Locations</span>
                <span class="tw-text-gray-600 tw-text-xs">Add all your locations so you can offer member plans and track the success at each one.</span>
              </div>
            </div>
            <div class="tw-flex-none tw-w-4 tw-h-4 tw-my-auto">
              <chevron-right-icon />
            </div>
          </div>
        </base-list-item>
        <base-list-item class="tw-cursor-pointer hover:tw-bg-gray-50">
          <div class="tw-flex tw-justify-between" @click="href(`/businesses/${businessId}/business/merchant`)">
            <div class="tw-flex">
              <div class="tw-my-auto tw-mr-6">
                <base-checkbox disabled v-if="!hasMerchantProcessing" />
                <base-checkbox disabled :value="1" :values="[1]" class="tw-text-green-500" v-if="hasMerchantProcessing" />
              </div>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-800">Connect to Stripe</span>
                <span class="tw-text-gray-600 tw-text-xs">Predictile uses Stripe to process secure card payments and to provide world class fraud detection.</span>
              </div>
            </div>
            <div class="tw-flex-none tw-w-4 tw-h-4 tw-my-auto">
              <chevron-right-icon />
            </div>
          </div>
        </base-list-item>
        <base-list-item class="tw-cursor-pointer hover:tw-bg-gray-50">
          <div class="tw-flex tw-justify-between" @click="href(`/businesses/${businessId}/business/subscription/details`)">
            <div class="tw-flex">
              <div class="tw-my-auto tw-mr-6">
                <base-checkbox disabled v-if="!hasSubscription" />
                <base-checkbox disabled :value="1" :values="[1]" class="tw-text-green-500" v-if="hasSubscription" />
              </div>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-800">Activate Subscription</span>
                <span class="tw-text-gray-600 tw-text-xs">Activate your Predictile subscription to begin offering subscriptions to your members.</span>
              </div>
            </div>
            <div class="tw-flex-none tw-w-4 tw-h-4 tw-my-auto">
              <chevron-right-icon />
            </div>
          </div>
        </base-list-item>
        <base-list-item class="tw-cursor-pointer hover:tw-bg-gray-50">
          <div class="tw-flex tw-justify-between" @click="href(`/businesses/${businessId}/plans`)">
            <div class="tw-flex">
              <div class="tw-my-auto tw-mr-6">
                <base-checkbox disabled v-if="!hasProductsAndPlans" />
                <base-checkbox disabled :value="1" :values="[1]" class="tw-text-green-500" v-if="hasProductsAndPlans" />
              </div>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-800">Create Products and Plans</span>
                <span class="tw-text-gray-600 tw-text-xs">Configure the plans you offer to your members.</span>
              </div>
            </div>
            <div class="tw-flex-none tw-w-4 tw-h-4 tw-my-auto">
              <chevron-right-icon />
            </div>
          </div>
        </base-list-item>
        <base-list-item class="tw-cursor-pointer hover:tw-bg-gray-50">
          <div class="tw-flex tw-justify-between" @click="href(`/businesses/${businessId}/business/brand`)">
            <div class="tw-flex">
              <div class="tw-my-auto tw-mr-6">
                <base-checkbox disabled v-if="!hasBrandColorsAndLogo" />
                <base-checkbox disabled :value="1" :values="[1]" class="tw-text-green-500" v-if="hasBrandColorsAndLogo" />
              </div>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-800">Configure Brand Colors and Logo</span>
                <span class="tw-text-gray-600 tw-text-xs"
                  >Set your business logo and your color scheme to allow you brand to show through all emails sent to your memebrs and on your signup page.</span
                >
              </div>
            </div>
            <div class="tw-flex-none tw-w-4 tw-h-4 tw-my-auto">
              <chevron-right-icon />
            </div>
          </div>
        </base-list-item>
        <base-list-item class="tw-cursor-pointer hover:tw-bg-gray-50">
          <div class="tw-flex tw-justify-between" @click="href(`/businesses/${businessId}/business/taxrates`)">
            <div class="tw-flex">
              <div class="tw-my-auto tw-mr-6">
                <base-checkbox disabled v-if="!hasTaxRates" />
                <base-checkbox disabled :value="1" :values="[1]" class="tw-text-green-500" v-if="hasTaxRates" />
              </div>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-gray-800">Set Tax Rates (optional)</span>
                <span class="tw-text-gray-600 tw-text-xs">Customize your tax rate at each location and have that automatically added to your products and plans.</span>
              </div>
            </div>
            <div class="tw-flex-none tw-w-4 tw-h-4 tw-my-auto">
              <chevron-right-icon />
            </div>
          </div>
        </base-list-item>
      </base-list-group>
    </div>
  </base-content>
</template>
<script>
import { mapGetters } from "vuex";
import { ChevronRightIcon } from "@/assets/svgs";
export default {
  name: "BusinessActivationView",
  components: {
    ChevronRightIcon,
  },
  props: {
    businessId: String,
  },
  computed: {
    ...mapGetters("businessActivation", [
      "hasBusinessProfile",
      "hasTaxRates",
      "hasLocation",
      "hasSubscription",
      "hasProductsAndPlans",
      "hasBrandColorsAndLogo",
      "hasMerchantProcessing",
    ]),
  },
  methods: {
    href(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>
